import { render } from "./SideBarMenuLv2.vue?vue&type=template&id=02c8f422&scoped=true"
import script from "./SideBarMenuLv2.vue?vue&type=script&lang=js"
export * from "./SideBarMenuLv2.vue?vue&type=script&lang=js"

import "./SideBarMenuLv2.vue?vue&type=style&index=0&id=02c8f422&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c8f422"]])

export default __exports__